import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ScheduleAutoAssignDialogItem } from '../schedule-auto-assign-dialog/schedule-auto-assign-dialog.component';

export interface ScheduleTeamLeaderCoveragePlanItem {
  leagueShortName: string;
  teamLeaderName: string;
  coverage: number;
}

export interface ScheduleTeamLeaderAssignDialogData {
  gameCount: number;
  autoAssignGameLimit: number;
  filterItems: ScheduleAutoAssignDialogItem[];
  coveragePlan: ScheduleTeamLeaderCoveragePlanItem[];
  validationErrors: string[];
}

@Component({
  selector: 'app-schedule-team-leader-assign-dialog',
  templateUrl: './schedule-team-leader-assign-dialog.component.html',
  styleUrls: ['./schedule-team-leader-assign-dialog.component.css']
})
export class ScheduleTeamLeaderAssignDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ScheduleTeamLeaderAssignDialogData,
    private dialogRef: MatDialogRef<
      ScheduleTeamLeaderAssignDialogComponent,
      boolean
    >
  ) {}

  get countExceedsLimit(): boolean {
    return this.data.gameCount > this.data.autoAssignGameLimit;
  }

  get canConfirm(): boolean {
    return (
      this.data.gameCount > 0 &&
      !this.countExceedsLimit &&
      this.data.validationErrors.length === 0
    );
  }

  close(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }
}
